import { render, staticRenderFns } from "./mediaApprovalGallery.vue?vue&type=template&id=6968cf49&scoped=true&"
import script from "./mediaApprovalGallery.vue?vue&type=script&lang=js&"
export * from "./mediaApprovalGallery.vue?vue&type=script&lang=js&"
import style0 from "./mediaApprovalGallery.vue?vue&type=style&index=0&id=6968cf49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968cf49",
  null
  
)

export default component.exports